import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import { Navbar } from "./navbar/navbar";
import { Home } from './home/home';
import { AboutUs } from "./about-us/about-us";
import { OurWorks } from "./our-works/our-works";
import { Projects } from "./projects/projects";
import { Location } from "./location/location";
import { Footer } from "./footer/footer";
import { Contact } from "./contact/contact";
import { ConceptLine } from './concept-line/concept-line';

const App = () => {
    const [view, setView] = useState<'home'|'projects'>('home');
    const bodyRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        // when switching views, scroll to top for clarity
        if ((view === 'home' || view === 'projects') && bodyRef.current) {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    }, [view])

    const handleNavigate = (target: string) => {
        if (target === 'projects') {
            setView('projects');
            return;
        }
        // for other targets, ensure home view is visible and scroll to element
        setView('home');
        setTimeout(() => {
            const el = document.getElementById(target);
            if (el) el.scrollIntoView({behavior: 'smooth'});
        }, 50);
    }

    return (
        <div className="app">
            <Navbar onNavigate={handleNavigate}/>
            <div className="body-content" ref={bodyRef}>
                {view === 'home' ? (
                    <>
                        <Home/>
                        <AboutUs/>
                        <OurWorks/>
                        <ConceptLine/>
                        <Location/>
                        <Contact/>
                    </>
                ) : (
                    <Projects/>
                )}
            </div>
            <Footer onNavigate={handleNavigate} />
        </div>
    );
}

export default App; 
